import {InputElement} from "./input-element.js";

/**
 * Represents a hidden input element, extending the functionality of the InputElement class.
 * This class is used to handle hidden input elements within a form structure.
 */
export class HiddenElement extends InputElement {
    value;

    get dataValue() {
        return this.domComponent.value;
    }

    set dataValue(value) {
        super.dataValue = value;
        this.domComponent.value = value;
    }

    /**
     * Constructor for initializing an instance of the class.
     *
     * @param {Object} formData - The data associated with the form.
     * @param {HTMLElement} parentElement - The parent HTML element where the form will be rendered.
     * @param {Array} collection - A collection of items related to
     */
    constructor(formData, parentElement, collection) {
        super(formData, parentElement, collection);
    }


    /**
     * Removes or culls unnecessary listeners associated with the given component.
     *
     * @param {Object} component - The component for which listeners are to be culled.
     */
    defaultListeners(component) {
        /* cull listeners for this element */
    }

    /**
     * Retrieves the type of input element.
     *
     * @return {string} A string representing the input type, specifically "hidden".
     */
    inputType() {
        return "hidden";
    }

    /**
     * Wraps and returns the parent element of the current context.
     *
     * @return {HTMLElement} The parent element of the current context.
     */
    componentWrapper() {
        return this.parentElement;
    }

    /**
     * Creates and returns a component with the current value assigned.
     *
     * @return {Object} The modified component with the current value applied to it.
     */
    component() {
        const hiddenComponent = super.component();
        return hiddenComponent;
    }

    /**
     * Method executed after the rendering of the component.
     * Ensures that the `dataValue` property is updated based on the current `value`.
     *
     * @return {void} Does not return a value.
     */
    postRender() {
        super.postRender();

        this.dataValue = this.value ?? "";
    }

}
